import { render, staticRenderFns } from "./salesInstallmentsTable.vue?vue&type=template&id=257b6fa0&"
import script from "./salesInstallmentsTable.vue?vue&type=script&lang=js&"
export * from "./salesInstallmentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports